import React from "react";

const About = () => {
    return (
        <div style={{ padding: "20px", textAlign: "center" }}>
            <h1 style={{ color: "#004b8d" }}>À Propos de Nous</h1>
            <p>
                Bienvenue sur Nomidya, une plateforme e-learning dédiée à fournir des cours de qualité dans divers domaines,
                notamment la technologie, la data science, et bien plus encore.
            </p>
            <img src="/images/feedback-bg.jpg" alt="À propos de nous" style={{ width: "100%", maxHeight: "400px", objectFit: "cover" }} />
        </div>
    );
};

export default About;
